module.exports = __webpack_public_path__ + "static/media/EasyLabImageStep2.f0c0a824.png";